function nunjucks_global_topic_colors()
{
    this.name = 'topic_colors';
    this.value = {
        "Árak": "#008FCB",
        "Belkereskedelem": "#7A8A7D",
        "Egészségügy, baleset": "#EB690B",
        "Energiagazdálkodás": "#008FCB",
        "Építőipar": "#007790",
        "Gazdasági és nonprofit szervezetek, beruházások": "#008FCB",
        "Igazságszolgáltatás": "#542248",
        "Információ, kommunikáció": "#3D777C",
        "Ipar": "#007790",
        "Jövedelmi viszonyok, életkörülmények": "#7D1F1F",
        "Környezet": "#8BA70A",
        "Kultúra, sport": "#86184F",
        "Kutatás-fejlesztés, innováció": "#008FCB",
        "Külkereskedelem": "#008FCB",
        "Lakás, kommunális ellátás": "#7D1F1F",
        "Mezőgazdaság": "#4D6811",
        "Munkaerőpiac": "#964B38",
        "Nemzeti számlák, GDP": "#008FCB",
        "Népesség, népmozgalom": "#803689",
        "Oktatás": "#86184F",
        "Pénzügyek": "#008FCB",
        "Szállítás, közlekedés": "#7A8A7D",
        "Szociális védelem": "#F2963F",
        "Turizmus, vendéglátás": "#7A8A7D",
        "Területi statisztika": "#925036",
        "Nemzetközi statisztika": "#FABD43",
        
        "Folyóiratok": "#004687",
        
        "Módszertani kiadványok, nómenklatúrák": "#92839B",
        "Összefoglaló kiadványok": "#C6C7C8",
        "Területi összefoglaló kiadványok": "#925036",
        "Társadalomstatisztikai összefoglaló kiadványok": "#A8353A",
        "Gazdaságstatisztikai összefoglaló kiadványok": "#008FCB"
    };
}